import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { CustomTableComponent } from "../../../shared/ui/custom-table/components/table/custom-table.component";


import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { GrantListComponent } from "./components/grant-list/grant-list.components";
import { GrantDetailTabsComponent } from "./components/grant-detail-tabs/grant-detail-tabs.component";
import { GrantFormV2Component } from "./components/grant-form/grant-form.component";
import {GrantReducer} from './store/reducers/grant.reducer'
import {GrantEffects} from './store/effects/grant.effects'
import { SharedModule } from "../../shared/shared.module";
import { SharedModule as CompanyModeSharedModule } from "../../../shared/shared.module";




@NgModule({
  declarations:[
    GrantListComponent,
    GrantDetailTabsComponent,
    GrantFormV2Component,
  ],
  exports:[
    GrantListComponent,
    GrantFormV2Component,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    CompanyModeSharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatCheckboxModule,

    // NgRx
    StoreModule.forFeature('grant', GrantReducer),
    EffectsModule.forFeature([GrantEffects])
  ],
})

export class GrantModule { }
